import { postJson } from "../config/fetch.api";
import OnboardingResponseBody from "./OnboardingResponseBody";

export interface chooseAnIdDocumentDto {
  country_of_issue: string;
  document_type: "passport" | "driving_licence"
  has_uploaded_file: boolean;
  passport_number: string; 
  license_number: string;
}

export const postChooseAnIdDocument = async (chooseAnIdDocument: chooseAnIdDocumentDto): Promise<OnboardingResponseBody> => 
  postJson(
    Routes.api_onboarding_choose_an_id_document_path(),
    JSON.stringify(chooseAnIdDocument),
    false,
  )